import React, { useState, useEffect } from 'react';
import { Grid, IconButton, Stack, FormLabel, Tooltip } from '@mui/material';
import '../../../assets/scss/autoComplete.scss';
import { ValidatorForm} from 'react-material-ui-form-validator';
import format from 'date-fns/format';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { getUsersList, setUsersList } from '../../../redux/slice/usersListSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid, GridActionsCellItem, GridToolbarContainer } from '@mui/x-data-grid';
import { Edit, View } from '../../../assets/icons';
import Switch from './switch';
import SwitchStatusDialog from './switchStatusDialog';
import ROUTES from '../../../utils/routes';
import { ROLES } from '../../../utils/config';
import { updateUserData } from '../../../redux/slice/manageUserSlice';
import { CommonButton } from '../../../Components/common/commonButton';
import { CommonPaginationContainer, CommonSelect } from '../../../Components/common';
import VisibilityIcon from "@mui/icons-material/Visibility";
import instance from "../../../redux/api";
import { exportUsers, getPaginatedUsers } from '../../../Services/api';
import { toast } from "react-toastify";
import { useStyles } from '../../../Components/bankTransactions/bankTranscationContainerStyles';
import { commonToast } from '../../../Components/common';
import { customDateFormat } from "../../../Components/CashAllocation/utils";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const userListaddUser = {
  color: 'white',
  backgroundColor: '#FF5A01',
  borderRadius: '20px',
  marginRight: '10px',
};


const UserList = () => {
  const { usersList } = useSelector((state) => state?.usersList);
  const { userData } = useSelector((state) => state?.user);
  const isUserListLoading = useSelector(
    (state) => state?.usersList?.isUserListLoading
  );
  const toggle = useSelector((state) => state.toggleSideMenu);

  const container = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  const [formdata, setFormData] = useState({
    name: "",
    startdate: "",
    enddate: "",
    status: "",
    role: "",
    email: "",
  });

  const [switchDialog, setSwitchDialog] = useState({
    id: "",
    status: "",
    isOpen: false,
  });
  const [searchResult, setsearchResult] = useState([]);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isAuditOpen, setIsAuditOpen] = useState(false);
  const classes = useStyles();

  /*
  // Trigger search logic whenever form data changes
  useEffect(() => {
    handleSubmitSearch();
  }, [formdata, usersList]);
  */

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsersList());
  }, []);

  const userManagement =
    userData?.user_permissions?.permissions_list["User Management"] ?? {};

  const displayActionsColumn =
    userManagement?.Add?.toUpperCase() === "Y" ||
    userManagement?.Edit?.toUpperCase() === "Y" ||
    userManagement?.View?.toUpperCase() === "Y" ||
    userManagement?.["In-Active"]?.toUpperCase() === "Y";

  /*
  const handleSubmitSearch = async () => {
    setsearchResult([]);
    var newSearchArr = [];
    if (formdata.name && formdata.role && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          opt.role &&
          formdata.role === opt.role &&
          opt.status &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name && formdata.role) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          opt.role &&
          formdata.role === opt.role
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.role && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.role &&
          formdata.role === opt.role &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase())
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.role) {
      usersList.find((opt) => {
        if (opt.role && formdata.role === opt.role) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.status) {
      usersList.find((opt) => {
        if (formdata.status === opt.status) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else {
      // setnoSearchResultData(false);
    }
     setsearchResult(newSearchArr);
    // setnoSearchResultData(newSearchArr.length === 0);
  };
  */

  // Calculate the starting and ending indices for the current page
  // const startIndex = page * rowsPerPage;
  // const endIndex = Math.min(startIndex + rowsPerPage, usersList.length);
  // const paginatedData = usersList?.slice(startIndex, endIndex);

  const navigate = useNavigate();

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  useEffect(() => {
    if (pageState?.total >= 5) {
      setPaginationCount(Math.floor(pageState.total / pageState?.pageSize));
    } else setPaginationCount(0);
  }, [pageState.total]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (isSearchPerformed) {
        const { name, role, status } = formdata;
        if (name) {
          queryParams = `${queryParams}&userName=${name}`;
        }
        if (role) {
          queryParams = `${queryParams}&userRole=${role}`;
        }
        if (status) {
          queryParams = `${queryParams}&userStatus=${status}`;
        }
      }
      const response = await instance.get(
        `${getPaginatedUsers}?${queryParams}`
      );
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleInputFieldChange = (name, value) => {
    setFormData({
      ...formdata,
      [name]: value ?? ""
    });
    if (isSearchPerformed && !value) {
      const searchFields = formdata;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };

  const handleSearchUserList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const { name, role, status } = formdata;
      if (name) {
        queryParams = `${queryParams}&userName=${name}`;
      }

      if (role) {
        queryParams = `${queryParams}&userRole=${role}`;
      }
      if (status) {
        queryParams = `${queryParams}&userStatus=${status}`
      }

      setPageState((old) => ({
        ...old,
        isLoading: true
      }));

      const response = await instance.get(`${getPaginatedUsers}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ? response?.data?.data : [],
          page: 1
        }));
        setIsSearchPerformed(true);
        setPaginationCount(Math.floor(response?.data?.count / pageState?.pageSize));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }

    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true
      }));
      console.log("err", err);
    }
  };

  const handleClearSearchList = () => {
    setIsSearchPerformed(false);
    setFormData({
      ...formdata,
      name: "",
      role: "",
      status: ""
    })
    setPageState((old) => ({
      ...old,
      page: 1
    }));
    setIsClearPerformed(true);
  }

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { name, role, status } = formdata;
    if (name !== "" || role !== "" || status !== "") {
      disabled = false;
    }
    return disabled;
  }

  const handleExportBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${exportUsers}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Users_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Users data has been exported successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Users data could not be exported");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Users data could not be exported");
    }
  }

  const handleAddBtnClick = () => {
    navigate(ROUTES.AUMAU);
  };

  const handleDecryptClick = async (id, type, record_id = null) => {
    try {
      const response = await instance.post(`/users/user-data-decryption/`, { id, type, record_id });
      if (response.status !== 200) return;
  
      const decryptedValue = response.data;
  
      // --- Case 1: Update a specific record inside currentRow ---
      if (record_id) {
        const keyToUpdate =
          type === "new_email_value" ? "new_value" : "old_value";
        const valueToUpdate =
          type === "new_email_value"
            ? decryptedValue.new_email_value
            : decryptedValue.old_email_value;
  
        const updatedUserAuditData = currentRow?.user_audit_data?.map((audit) =>
          record_id === audit.id ? { ...audit, [keyToUpdate]: valueToUpdate } : audit
        );
  
        setCurrentRow((prev) => ({
          ...prev,
          user_audit_data: updatedUserAuditData,
        }));
  
        return;
      }
  
      // --- Case 2: Update user list ---
      // Update only the currently visible paginated data by id
      setPageState((old) => ({
        ...old,
        data: (old?.data ?? []).map((row) =>
          row?.id === id
            ? { ...row, decrypted_email: decryptedValue?.decrypted_email }
            : row
        ),
      }));
  
    } catch (error) {
      console.error("Failed to decrypt:", error);
    }
  };  

  const [currentRow, setCurrentRow] = useState("");
  const handleActionButton = (currentRowData) => {
    setCurrentRow(currentRowData);
    setIsAuditOpen(true);
  };

  let columns = [
    {
      field: "user_name",
      headerName: "User Name",
      headerAlign: "center",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "decrypted_email",
      headerName: "Email",
      headerAlign: "center",
      minWidth: 300,
      flex: 2.5,
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {params.value}
          {userData?.role?.toLowerCase() === "manager" && (
            <IconButton
              onClick={() => handleDecryptClick(params.id, 'decrypted_email')}
              size="small"
            >
              <VisibilityIcon />
            </IconButton>
          )}
        </div>
      ),
    },
    {
      field: "division",
      headerName: "Division",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: ({ row }) => row?.division?.entity_divisions,
    },
    {
      field: "role",
      headerName: "Role",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "reporting_manager",
      headerName: "Reporting Manager",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
      valueGetter: ({ row }) => row?.reporting_manager?.user_name,
    },
    {
      field: "user_start_date",
      headerName: "User Start Date",
      headerAlign: "center",
      minWidth: 120,
      flex: 1,
      valueGetter: ({ row }) =>
        row?.user_start_date
          ? customDateFormat(row?.user_start_date)
          : "",
    },
    {
      field: "user_end_date",
      headerName: "User End Date",
      headerAlign: "center",
      minWidth: 120,
      flex: 1,
      valueGetter: ({ row }) =>
        row?.user_end_date
          ? customDateFormat(row?.user_end_date)
          : "",
    },
    {
      field: "department",
      headerName: "Department",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
    },
  ];

  if (displayActionsColumn) {
    columns.push({
      field: "actions",
      headerAlign: "center",
      minWidth: 200,
      flex: 1,
      type: "actions",
      headerName: "Actions",
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];
        if (userManagement?.View?.toUpperCase() === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={<View />}
              label="View"
              className="textPrimary"
              onClick={() => {
                navigate(ROUTES.AUMVU);
                dispatch(updateUserData(row));
              }}
              color="inherit"
            />
          );
        }

        if (userManagement?.Edit?.toUpperCase() === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={<Edit />}
              label="Edit"
              onClick={() => {
                navigate(ROUTES.AUMEU);
                dispatch(updateUserData(row));
              }}
              color="inherit"
            />
          );
        }

        if (userManagement?.["In-Active"]?.toUpperCase() === "Y") {
          actionsList.push(
            <GridActionsCellItem
              key={row?.status}
              icon={
                <Switch
                  key={row?.id}
                  {...row}
                  inputProps={{ "aria-label": "User Status" }}
                  checked={
                    row?.status === "Active" || row?.status === "Activate"
                  }
                />
              }
              label="Status"
              className="textPrimary"
              onClick={() =>
                setSwitchDialog({
                  id: row?.id,
                  status: row?.status,
                  isOpen: true,
                })
              }
              color="inherit"
            />
          );
        }

        if (userManagement?.Edit?.toUpperCase() === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Audit Trail">
                  {" "}
                  <EditNoteIcon />{" "}
                </Tooltip>
              }
              label="audit"
              className="textPrimary"
              onClick={() => handleActionButton(row)}
              color="inherit"
            />
          );
        }

        return actionsList;
      },
    });
  }


  const UserListBox = {
    display: "flex",
    justifyContent: "space-between",
    height: 32,
    fontWeight: "400",
    marginTop: 10,
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchUserList();
    }
  };
  
  const handleCloseDialogs = () => {
    setIsAuditOpen(false);
  };

  return (
    <div style={container}>
      <div style={UserListBox}>
        <span style={{ color: "#FF5A01", fontSize: "24px" }}>Users List </span>
          {userManagement?.Add?.toUpperCase() === "Y" && (
          <div style={{display:'flex' ,flexDirection:'row'}}>
            <CommonButton
              text="Add User"
              handleClick={handleAddBtnClick}
              sx={userListaddUser}
              hoverColor="#FF5A01"
            />
            <CommonButton
            text="Export Users"
            handleClick={handleExportBtnClick}
            sx={userListaddUser}
            hoverColor="#FF5A01"
            disabled={isDownloadInProgress}
            />
          </div>
            )}
      </div>

      {/* <ValidatorForm onSubmit={handleSubmitSearch} onError={() => null}> */}
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Name</span>
              <input
                name="name"
                value={formdata?.name}
                onChange={(e) =>
                handleInputFieldChange("name", e.target.value)
                }
                className="inputField"
                placeholder="Search..."
                style={{ height: "32px", marginTop: "5px" }}
                onKeyUp={(e) => handleEnter(e)}
              />
            </div>
          </Grid>
          <Grid item xs={3}>
            <div style={{ marginBottom: 4 }}>Role</div>
            <div onKeyUp={(e) => handleEnter(e)}>
            <CommonSelect
              name="role"
              value={formdata?.role}
              placeholder="Select Role"
              handleChange={(event, value, reason) =>
                handleInputFieldChange("role", value)
              }
              options={ROLES}
            />
            </div>
          </Grid>
          <Grid item xs={3}>
            <div style={{ marginBottom: 4 }}>Status</div>
            <div onKeyUp={(e) => handleEnter(e)}>
            <CommonSelect
              name="status"
              value={formdata?.status}
              placeholder="Select Status"
              handleChange={(event, value, reason) =>
                handleInputFieldChange("status", value)
              }
              options={["Active", "Inactive"]}
            />
            </div>
          </Grid>
          <Grid 
            item 
            xs={3}
            mt={"28px"}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: "10px",
            }}>
            <FormLabel></FormLabel>
            <CommonButton
              text="Search"
              handleClick={handleSearchUserList}
              hoverColor="#EE3F00"
              disabled={pageState?.isLoading || isFilterBtnDisable()}
            />
            <FormLabel></FormLabel>
            <CommonButton
              text="Clear"
              handleClick={handleClearSearchList}
              hoverColor="#EE3F00"
              disabled={pageState?.isLoading || isFilterBtnDisable()}
              style={{ color: isFilterBtnDisable() ?? "rgba(0, 0, 0, 0.26)" }}
            />
          </Grid>
        </Grid>
      {/* </ValidatorForm> */}

      {/*
      <div
        style={{
          height: 600,
        }}
      >
        <DataGrid
          loading={isUserListLoading}
          rows={
            formdata.name || formdata.role || formdata.status
              ? searchResult
              : usersList
          }
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[
            { label: "5", value: 5 },
            { label: "10", value: 10 },
            { label: "25", value: 25 },
            { label: "50", value: 50 },
            { label: "100", value: 100 },
          ]}
          autoPageSize={true}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          disableColumnMenu
        />
      </div>
      */}
      <div
        style={{
          height: 'calc(100vh - 296px)',
          position: "relative",
          display: "flex",
          flexDirection: "row-reverse",
          overflowX: "auto",
          width: "100%",
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          columns={columns}
          rowCount={pageState?.total}
          // hideFooterPagination
          // hideFooter
          keepNonExistentRowsSelected
          disableSelectionOnClick
          pagination
          paginationMode="server"
          getRowId={(row) => row?.id}
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 10}
          pageSizeOptions
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(Math.floor(pageState.total / newPageSize));
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          components={{
            Toolbar: GridToolbarContainer, // Custom toolbar for filter reset button
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No User
              </Stack>
            ),
          }}
          sx={{
            "& .MuiDataGrid-columnHeader[data-field='actions']": {
              minWidth: toggle?.isOpen ? "260px !important" : "303px !important"
            }
          }}
        />
        <Stack
          style={{
            position: "absolute",
            bottom: "8px",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
      </div>

      <SwitchStatusDialog
        {...switchDialog}
        setSwitchDialog={setSwitchDialog}
        onSuccess={(updatedId, updatedStatus) => {
          // Update only currently paginated data by id so filtering/pagination stays consistent
          setPageState((old) => ({
            ...old,
            data: (old?.data ?? []).map((row) =>
              row?.id === updatedId ? { ...row, status: updatedStatus } : row
            ),
          }));
        }}
      />

      {/* User Audit model */}
      {isAuditOpen && (
        <Dialog 
          open={isAuditOpen} 
          onClose={handleCloseDialogs} 
          maxWidth='lg'
          fullWidth
          sx={{ width: "100%", height: "80vh", marginTop: "5%" }}
        >
          <DialogTitle sx={{fontSize: "1.5rem"}}>Audit Trail</DialogTitle>
          <DialogContent sx={{ overflow: "hidden", height: "70vh" }}>
            <Grid container spacing={2} mt={2} paddingLeft={2}>
              <Grid item xs={12}>
                <div style={{height: "50vh", overflowY: "auto"}}>
                  <table style={{width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f5f5f5' }}>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRow && currentRow?.user_audit_data?.map((audit, index) => (
                        <tr key={audit?.id}>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.field_name}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {audit?.old_value} 
                            {(audit?.field_name==='email') && userData?.role?.toLowerCase() === "manager" && (
                              <IconButton
                                onClick={() => handleDecryptClick(currentRow.id, 'old_email_value', audit?.id)}
                                size="small"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            )}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {audit?.new_value}
                            {(audit?.field_name==='email') && userData?.role?.toLowerCase() === "manager" && (
                              <IconButton
                                onClick={() => handleDecryptClick(currentRow.id, 'new_email_value', audit?.id)}
                                size="small"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            )}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.changed_by}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.current_time}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.event_type === 'add' ? 'Added bank statement' : audit?.event_type}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default UserList;
